module.exports = __webpack_public_path__ + "img/pt.af82a01f.png";